"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitions = {
    easing: {
        easeInOut: "ease-in-out",
        easeOut: "ease-out",
        easeIn: "ease-in"
    },
    duration: {
        short: 150,
        default: 300
    }
};
exports.default = exports.transitions;
//# sourceMappingURL=transitions.js.map